import clubRoutes from '../router/modules/club'
import customerRoutes from '../router/modules/customers'
import inventoryRoutes from '../router/modules/inventory'
import orderRoutes from '../router/modules/orders'
import productRoutes from '../router/modules/products'
import marketingRoutes from '../router/modules/marketing'
import deliveryRoutes from '../router/modules/deliveries'
import nsvRoutes from '../router/modules/nsv'
import { getClubName } from './subscriptions'

export const navigation = {
	admin: {
		navigation: [
			{
				title: 'Club',
				links: [
					clubRoutes.cargos,
					clubRoutes.suscripciones,
					clubRoutes.suscripcionesPausadas,
					clubRoutes.suscritores,
					clubRoutes.cancelaciones,
					clubRoutes.prospectos,
					clubRoutes.experiencias,
					clubRoutes.incentivos,
					clubRoutes.beneficios,
					clubRoutes.customerJourney,
					clubRoutes.multipleSubscriptions,
					clubRoutes.postTastingMetrics
				]
			},
			{
				title: getClubName('nunca_sin_vino'),
				links: [nsvRoutes.customerJourney]
			},
			{
				title: 'Inventario',
				links: [
					inventoryRoutes.entradas,
					inventoryRoutes.crearEntrada,
					inventoryRoutes.salidas,
					inventoryRoutes.crearSalida,
					inventoryRoutes.ventas,
					inventoryRoutes.revisarSalidas,
					inventoryRoutes.traspasos,
					inventoryRoutes.planearTraspaso,
					inventoryRoutes.crearMultiTraspaso,
					inventoryRoutes.inventario,
					inventoryRoutes.ubicaciones,
					inventoryRoutes.ajustes,
					inventoryRoutes.actualizarInventario,
					inventoryRoutes.suscripcionesCharges
				]
			},
			{
				title: 'Pedidos',
				links: [orderRoutes.pedidos]
			},
			{
				title: 'Clientes',
				links: [
					customerRoutes.clientes,
					customerRoutes.crearCliente,
					customerRoutes.interactions,
					customerRoutes.seguimientoInteracciones,
					customerRoutes.tags
				]
			},
			{
				title: 'Productos',
				links: [productRoutes.productos, productRoutes.crearProducto, productRoutes.fichasChidas]
			},
			{
				title: 'Marketing',
				links: [marketingRoutes.blasts, marketingRoutes.crearBlast, marketingRoutes.templates]
			},
			{
				title: 'Rutas',
				links: [deliveryRoutes.pendientes, deliveryRoutes.entregas]
			}
		]
	},

	oficina: {
		navigation: [
			{
				title: 'Club',
				links: [
					clubRoutes.cargos,
					clubRoutes.suscripciones,
					clubRoutes.suscripcionesPausadas,
					clubRoutes.suscritores,
					clubRoutes.cancelaciones,
					clubRoutes.prospectos,
					clubRoutes.experiencias,
					clubRoutes.incentivos,
					clubRoutes.beneficios,
					clubRoutes.customerJourney,
					clubRoutes.multipleSubscriptions,
					clubRoutes.postTastingMetrics
				]
			},
			{
				title: getClubName('nunca_sin_vino'),
				links: [nsvRoutes.customerJourney]
			},
			{
				title: 'Inventario',
				links: [
					inventoryRoutes.entradas,
					inventoryRoutes.crearEntrada,
					inventoryRoutes.salidas,
					inventoryRoutes.crearSalida,
					inventoryRoutes.ventas,
					inventoryRoutes.revisarSalidas,
					inventoryRoutes.traspasos,
					inventoryRoutes.planearTraspaso,
					inventoryRoutes.crearMultiTraspaso,
					inventoryRoutes.inventario,
					inventoryRoutes.ajustes,
					inventoryRoutes.actualizarInventario,
					inventoryRoutes.suscripcionesCharges
				]
			},
			{
				title: 'Pedidos',
				links: [orderRoutes.pedidos]
			},
			{
				title: 'Clientes',
				links: [
					customerRoutes.clientes,
					customerRoutes.crearCliente,
					customerRoutes.interactions,
					customerRoutes.seguimientoInteracciones,
					customerRoutes.tags
				]
			},
			{
				title: 'Productos',
				links: [productRoutes.productos, productRoutes.crearProducto, productRoutes.fichasChidas]
			},
			{
				title: 'Marketing',
				links: [marketingRoutes.blasts, marketingRoutes.crearBlast, marketingRoutes.templates]
			},
			{
				title: 'Rutas',
				links: [deliveryRoutes.pendientes, deliveryRoutes.entregas]
			}
		],
		hiddenRoutes: [
			customerRoutes.cliente,
			orderRoutes.pedido,
			clubRoutes.incentivo,
			customerRoutes.tag,
			clubRoutes.beneficio,
			productRoutes.producto,
			clubRoutes.postTasting,
			productRoutes.fichaChida,
			inventoryRoutes.pendingTransfer,
			inventoryRoutes.traspaso
		]
	},

	tienda: {
		links: [
			inventoryRoutes.inventario,
			inventoryRoutes.actualizarInventarioRetail,
			clubRoutes.experienciasRetail,
			clubRoutes.suscritores,
			deliveryRoutes.entregasRetail,
			customerRoutes.seguimientoInteracciones,
			productRoutes.fichasChidas,
			inventoryRoutes.traspasos,
			customerRoutes.clientes,
			customerRoutes.crearCliente
		],
		hiddenRoutes: [
			clubRoutes.postTasting,
			customerRoutes.cliente,
			orderRoutes.pedido,
			productRoutes.fichaChida,
			inventoryRoutes.traspaso
		]
	},

	logistica: {
		links: [
			clubRoutes.suscritores,
			inventoryRoutes.actualizarInventario,
			deliveryRoutes.entregas,
			inventoryRoutes.crearSalida,
			inventoryRoutes.traspasos,
			inventoryRoutes.planearTraspaso,
			inventoryRoutes.crearMultiTraspaso,
			inventoryRoutes.crearEntrada,
			inventoryRoutes.crearSalida,
			inventoryRoutes.inventario,
			inventoryRoutes.ajustes,
			customerRoutes.interactions,
			productRoutes.productos,
			deliveryRoutes.pendientes,
			customerRoutes.clientes
		],
		hiddenRoutes: [
			inventoryRoutes.traspaso,
			inventoryRoutes.pendingTransfer,
			productRoutes.producto,
			customerRoutes.cliente
		]
	},

	redes: {
		links: [productRoutes.productos, productRoutes.fichasChidas],
		hiddenRoutes: [productRoutes.producto, productRoutes.fichaChida]
	}
}

// Helper function to get all allowed route names for a user type
export function getAllowedRouteNames(userType) {
	const config = navigation[userType]
	if (!config) return []

	// Extract route names from navigation
	const navigationRouteNames = []
	config.navigation?.forEach((section) => {
		section.links?.forEach((link) => {
			navigationRouteNames.push(link.name)
		})
	})

	config.links?.forEach((link) => {
		navigationRouteNames.push(link.name)
	})

	// Add hidden routes if they exist
	config.hiddenRoutes?.forEach((link) => {
		navigationRouteNames.push(link.name)
	})

	// Always include home
	const allRouteNames = ['home', ...navigationRouteNames]

	return allRouteNames
}
